import { render, staticRenderFns } from "./ListaEmbarque.vue?vue&type=template&id=2f520a3d&scoped=true&"
import script from "./ListaEmbarque.vue?vue&type=script&lang=js&"
export * from "./ListaEmbarque.vue?vue&type=script&lang=js&"
import style0 from "./ListaEmbarque.vue?vue&type=style&index=0&id=2f520a3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f520a3d",
  null
  
)

export default component.exports